// extracted by mini-css-extract-plugin
module.exports = {"colorPicker":"colorPicker_colorPicker__228pf","removeColor":"colorPicker_removeColor__2bF6a","moreColors":"colorPicker_moreColors__8i8tk"};